<template>
	<div>
		<b-modal
			v-model="show"
			title="Mensagens Prontas"
			size="lg"
			centered
			scrollable
		>
			<!-- Adicione os botões aqui -->
			<div class="button-group">
				<button v-if="userActive" class="form-control new-category-button" @click="showCategoriesModal">
					<i class="fas fa-list"></i> Gerenciar Categoria
				</button>

				<button v-if="userActive" class="form-control new-message-button" @click="showRegisterMessageModal">
					<i class="fas fa-comment"></i> Adicionar Mensagem
				</button>
				</div>


				<b-container fluid>
  <b-row>
    <b-col cols="4" class="pl-0">
      <b-list-group class="h-100" v-if="!isBusca">
        <b-list-group-item
          v-for="(value, i) in tabs"
          :key="i"
          @click="showContent(i)"
          style="cursor:pointer;"
          class="d-flex justify-content-between align-items-center text-white"
          :class="[indexAtivo === i ? 'bg-active' : 'bg-adv']"
        >
          {{ value }}
          <b-icon icon="caret-right-fill" class="text-white"></b-icon>
        </b-list-group-item>

        <b-list-group-item class="d-flex justify-content-between align-items-center bg-adv text-white h-100">
        </b-list-group-item>
      </b-list-group>
    </b-col>

    <b-col cols="8" class="p-3">
      <b-alert
        show
        variant="info"
        v-if="indexAtivo !== null && categorias.length && mensagens.length"
      >
        <strong>Clique na mensagem para selecionar</strong>
      </b-alert>

      <b-alert
        show
        variant="info"
        v-if="indexAtivo !== null && categorias.length && !mensagens.length"
      >
        <strong>Não existem mensagens cadastradas nesta categoria. Por favor,
          {{ userActive ? "cadastre no botão 'Adicionar mensagem' acima" : "contate o seu supervisor" }}
        </strong>
      </b-alert>

      <b-alert
        show
        variant="info"
        v-else-if="indexAtivo === null && categorias.length"
      >
        <strong>Selecione uma categoria ao lado</strong>
      </b-alert>

      <b-alert
        show
        variant="info"
        v-else-if="!categorias.length"
      >
        <strong>Não existem categorias cadastradas. Por favor,
          {{ userActive !== null ? "cadastre no botão 'Gerenciar categoria' acima" : "contate o seu supervisor" }}
        </strong>
      </b-alert>

      <div v-if="mensagens.length">
        <div class="balloon" v-for="(msg, index) in mensagens" :key="index">
          <div class="balloon-content">
            <p
              @click="() => selectMessage(msg)"
              v-html="formatMessage(msg)"
              class="message-content"
            ></p>
            <div class="btn-group message-actions">
              <b-button
                v-if="userActive"
                size="sm"
                class="btn-icon"
                @click="editMessage(msg, index)"
              >
                <i class="fas fa-edit fa-2x icon-edit"></i>
              </b-button>
              <b-button
                v-if="userActive"
                size="sm"
                class="btn-icon"
                @click="deleteMessage(msg.id, index)"
              >
                <i class="fas fa-trash-alt fa-2x icon-delete"></i>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</b-container>


					<template #modal-footer>
						<div class="w-100 justify-content-center">
							<b-input-group>
								<b-form-input type="search" v-model="search" placeholder="Busque por uma mensagem" class="rounder"/>
								<b-input-group-append>
									<b-input-group-text class="justify-content-center">
										<b-icon icon="search" font-scale="1" variant="secondary"/>
									</b-input-group-text>
								</b-input-group-append>
							</b-input-group>
						</div>
					</template>
				</b-modal>

				<!-- Modal de Categorias -->
				<b-modal
				v-model="showCategories"
				title="Categorias"
				size="lg"
				centered
				scrollable
				>


				<b-container fluid class="d-flex flex-column" style="height: 500px;">
  <!--  formulário com 2 colunas -->
  <div style="position: sticky; top: 0; z-index: 2; background: white; padding-bottom: 10px;">
	<b-form @submit.prevent>
		<b-row>
        <b-col cols="7">
          <b-form-group label="Nome da categoria">
            <b-form-input
              v-model="newCategory"
              placeholder="Digite o nome da categoria"
            ></b-form-input>
          </b-form-group>

          <div v-if="categorias.length" class="category-list">
            <div
              :class="['category-item', index % 2 === 0 ? 'cinza' : 'branco']"
              v-for="(categoria, index) in categorias"
              :key="index"
            >
              <span>{{ categoria.name }}</span>
              <div class="actions">
                <button class="btn-icon" @click="editCategory(categoria, index)" v-if="userActive">
                  <i class="fas fa-edit icon-edit fa-lg"></i>
                </button>
                <button class="btn-icon" @click="deleteCategory(categoria, index)" v-if="userActive">
                  <i class="fas fa-trash-alt icon-delete fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </b-col>

		<b-col cols="5" class="d-flex flex-column"
		style="position: sticky; top: 0; z-index: 1; background: white;">
		<b-form-group label="Filas permitidas" class="flex-grow-1 d-flex flex-column">
			<div class="select-helper-text mb-1">Clique para selecionar/remover</div>
			<b-form-select
			v-model="queuechatSelecionadasCategoria"
			multiple
			class="flex-grow-1"
			:style="`height: ${Math.min(filasDisponiveis.length * 30, 400)}px`"
			>
			<b-form-select-option
				v-for="fila in filasDisponiveis"
				:key="fila.id"
				:value="fila.id"
				:title="fila.id === 0 ? 'Essa categoria será visível para qualquer fila' : ''"
			>
				{{ fila.name }}
			</b-form-select-option>
			</b-form-select>
		</b-form-group>
		</b-col>

      </b-row>
    </b-form>
  </div>
</b-container>



		<template #modal-footer>
		<div class="button-group w-100 justify-content-end">
			<div class="d-flex justify-content-end mt-3">
			<button class="cancel-button" @click="cancelEditing()" type="button">
				<i class="fas fa-times"></i> Cancelar
			</button>
			
			<button @click="addCategory" class="new-category-button ml-2" v-if="userActive">
				<i class="fas fa-list"></i>
				{{ isEditing ? 'Atualizar Categoria' : 'Cadastrar Categoria' }}
			</button>
			</div>
		</div>
		</template>

		</b-modal>


		<!-- Novo modal para cadastrar mensagem -->
		<b-modal
			v-model="showRegisterMessage"
			:title="isEditing ? 'Atualizar Mensagem' : 'Cadastrar Mensagem'"
			size="lg"
			centered
			scrollable
		>
			<b-container fluid>
				<!-- Conteúdo do modal de cadastrar mensagem -->
				<b-row>
					<b-col>
						<b-form @submit.prevent="registerMessage">
							<b-form-group label="Categoria">
								<b-form-select v-model="selectedCategory">
									<option :value="null" disabled>Selecione uma categoria</option>
									<option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">
										{{ categoria.name }}
									</option>
								</b-form-select>

							</b-form-group>
							<b-form-group label="Filas permitidas" v-if="false">
								<b-form-select
									v-model="queuechatSelecionadas"
									:options="filasDisponiveis"
									value-field="id"
									text-field="name"
									multiple
									required
									placeholder="Selecione uma fila"
								></b-form-select>
							</b-form-group>

							<b-form-group label="Mensagem" class="mb-0">
								<b-form-textarea rows="10" v-model="messageContent" placeholder="Digite o conteúdo da mensagem"></b-form-textarea>
							</b-form-group>
              <div class="alert alert-primary obs-span">
                Para negrito, envolva a palavra em asteriscos <strong>( * )</strong>.   Exemplo: *palavra* <br/>
                Para itálico, envolva a palavra em underlines <strong>( _ )</strong>.   Exemplo: _palavra_ <br/>
                Para sublinhado, envolva a palavra em til <strong>( ~ )</strong>.   Exemplo: ~palavra~ <br/>
                <strong>Obs: </strong> Não adicione espaços entre os caracteres especiais e a palavra.
              </div>
              <div class="message-button-group">
                <div class="message-variables-buttons">
                  <button class="form-control" @click.prevent="nameOperator()">Nome do consultor</button>
                  <button class="form-control" @click.prevent="nameUser()">Nome do cliente</button>
                </div>
                <button class="form-control save-button" type="submit"><i class="fas fa-save"></i>     {{ isEditing ? 'Atualizar Mensagem' : 'Cadastrar Mensagem' }}</button>
              </div>
						</b-form>
					</b-col>
				</b-row>
			</b-container>
			<template #modal-footer>
        <div class="button-group">
          <button class="cancel-button" @click="cancelEditingMessage()"><i class="fas fa-times"></i>     Cancelar</button>
        </div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

window.$eventMessage = new Vue();

export default {
	data:() => ({
		show: false,
		search: '',
		indexAtivo: null,
		queuechatSelecionadasCategoria: [],
		allMensagens: [],
		mensagensIndex: '',
		isBusca: false,
		nameContact: '',
		newCategory: '',
		categorias: [],
		showCategories: false,
		userActive: '',
		user: '',
		showRegisterMessage: false, 
		editingCategory: null,
		isEditing: false, 
		selectedCategory: null,
		messageContent: '', 
		queuechatSelecionadas: [],
		filasDisponiveis: [],
	}),


	created() {
		this.loadUserActive();
		this.loadCategories();
        this.loadMensagens();
	},

	computed: {
		...mapGetters(['getDataConnectLine']),

		tabs() {
			return this.categorias.map(categoria => categoria.name);
		},

		mensagens() {
			if (this.search.length >= 4) {
				return this.allMensagens?.flatMap(mensagemArray => {
					return mensagemArray.flatMap(item => {
						if (item) {
							return item.filter(mensagem => {
								return mensagem && mensagem.content && mensagem.content.match(new RegExp(this.search, 'gi'));
							});
						}
						return [];
					});
				});
			}

			if (this.allMensagens?.length && this.indexAtivo !== null) {
				const categoriaSelecionada = this.allMensagens[this.indexAtivo];


				if (Array.isArray(categoriaSelecionada)) {
					this.mensagensIndex = categoriaSelecionada.filter(mensagem => mensagem?.content !== null);
					return this.mensagensIndex || [];
				}
			}

			return [];
		}
			}
		,

	methods: {
		getCategoryById(id) {
		return this.categorias.find(cat => cat.id === id);
		},
		nameUser(){
			if(this.messageContent){
				this.messageContent += ' ' + '*%nome_contato%*';
			}else{
				this.messageContent = '*%nome_contato%*';
			}
		},

		nameOperator(){
			if(this.messageContent){
				this.messageContent += ' ' + `*${this.user}*`;
			}else{
				this.messageContent = `*${this.user}*`;
			}
		},
		loadUserActive() {
			axios.get('getUserActive')
				.then(response => {
				
				const activeStatus = parseInt(response.data.active);
				this.userActive = activeStatus === 1; 
				this.user = response.data.name;
				const ids = JSON.parse(response.data.queuechat || "[]");
				const names = response.data.queuechat_names || [];

				this.filasDisponiveis = ids.map((id, index) => ({
					id: id,
					name: names[index] || `Fila ${id}`
				}));


				})
				.catch(error => {
				console.error('Erro ao carregar dados do usuário:', error);
				});
			},


		loadCategories() {
			axios.get('quick-getCategories').then(response => {
                    this.categorias = response.data;
                })
                .catch(error => {
                    console.error('Erro ao carregar as categorias:', error);
                });
        },

		loadMensagens() {
			axios.get('getNewMessages')
				.then(response => {
				this.allMensagens = response.data; 
				})
				.catch(error => {
				console.error('Erro ao carregar as mensagens:', error);
				});
			},


		selectMessage(msg) {
            if (typeof msg === 'object' && typeof msg.content === 'string') {
                let result = msg.content.replace(/%nome_contato%/g, this.nameContact);
                $eventMessage.$emit('sendMensagem', result);
                this.show = false;
                this.search = '';
            } else {
                //console.error('Mensagem não é uma string:', msg);
				return "";
            }
        },
        formatMessage(msg) {
            if (typeof msg === 'object' && typeof msg.content === 'string') {
                let result = msg.content.replace(/%nome_contato%/g, this.nameContact);
                result = result.replace(/\n/g, "<br/>");
                return result;
            } else {
                //console.error('Mensagem não é uma string:', msg);
                return "";
            }
        },
		showContent(index) {
      console.log('allMensagens', this.allMensagens)
			this.indexAtivo = index;
		},

		showCategoriesModal() {
			this.showCategories = true; 
		},
		showRegisterMessageModal(){
			this.showRegisterMessage = true;
		},

		capitalizeFirstLetter (string) {
			return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
		},

		addCategory() {
			if (this.newCategory.trim() === '') return;

			const formattedCategory = this.capitalizeFirstLetter(this.newCategory);

			if (this.isEditing && this.editingCategory) {
				axios.post(`updateCategory`, {
					id: this.editingCategory.id,
					name: formattedCategory,
					queuechat: this.queuechatSelecionadasCategoria 
				}).then(() => {
					Swal.fire('Edição realizada', 'Categoria editada com sucesso!', 'success').then(() => {
						this.newCategory = '';
						this.queuechatSelecionadasCategoria = []; 
						this.isEditing = false;
						this.editingCategory = null;
						this.showCategories = false;
						this.loadCategories();
					});
				}).catch(error => {
					console.error('Erro ao editar a categoria:', error);
					Swal.fire('Erro', 'Houve um erro ao editar a categoria', 'error');
				});
			} else {
				axios.post("setCategories", {
					name: formattedCategory,
					queuechat: this.queuechatSelecionadasCategoria
				}).then(() => {
					Swal.fire('Inclusão realizada', 'Categoria inserida com sucesso!', 'success').then(() => {
						this.newCategory = '';
						this.queuechatSelecionadasCategoria = [];
						this.showCategories = false;
						this.loadCategories();
					});
				}).catch(error => {
					if (error.response?.data?.error === 'O nome da categoria já existe.') {
						Swal.fire('Erro', 'O nome da categoria já existe. Por favor, escolha outro nome.', 'error');
					} else {
						Swal.fire('Erro', 'Houve um erro ao cadastrar a categoria', 'error');
					}
				});
			}
		},

		editCategory(categoria, index) {
	this.editingCategory = categoria;
	this.newCategory = categoria.name;
	this.queuechatSelecionadasCategoria = Array.isArray(categoria.queuechat)
		? categoria.queuechat
		: JSON.parse(categoria.queuechat || "[]");
	this.isEditing = true;
	this.showCategories = true;
		},

		deleteCategory(categoria, index) {
			Swal.fire({
				title: 'Tem certeza?',
				text: "Você não poderá reverter isso!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Sim, deletar!'
			}).then((result) => {
				if (result?.value == true) {
					axios.delete(`deleteCategory/${categoria.id}`)
						.then(() => {
							Swal.fire(
								'Deletada!',
								'Categoria deletada com sucesso.',
								'success'
							);
							this.newCategory = '';
							this.showCategories = false;
							this.loadCategories();
						})
						.catch(error => {
							if (error.response && error.response.data && error.response.data.error === 'categoria contém mensagem.') {
								Swal.fire(
									'Erro',
									'A categoria possui mensagens associadas. Favor deletar as mensagens da categoria!',
									'error'
								);
							} else {
								Swal.fire(
									'Erro',
									'Houve um erro ao deletar a categoria',
									'error'
								);
							}
						});
				}
			});
		},
		cancelEditing() {
			this.isEditing = false;
			this.editingCategory = null;
			this.newCategory = '';
			this.showCategories = false;
		},

		cancelEditingMessage(){
			this.selectedCategory = null;
			this.messageContent = '';
			this.showRegisterMessage = false;
			this.isEditing = false;
			this.editingMessage = null;
		},

		registerMessage() {
			if (!this.selectedCategory || this.messageContent.trim() === '') {
				Swal.fire(
					'Erro',
					'Todos os campos são obrigatórios.',
					'error'
				);
				return;
			}

			const selectedCat = this.categorias.find(cat => cat.id === this.selectedCategory);
			const queuechat = selectedCat?.queuechat || [];

			const newMessage = {
				category_id: this.selectedCategory,
				content: this.messageContent,
				queuechat,
				id: this.isEditing ? this.editingMessage.id : ''
			};

			const apiUrl = this.isEditing ? `updateMessage/${this.editingMessage.id}` : 'registerMessage';

			axios.post(apiUrl, newMessage)
				.then(() => {
					Swal.fire(
						'Sucesso',
						this.isEditing ? 'Mensagem atualizada com sucesso!' : 'Mensagem cadastrada com sucesso!',
						'success'
					).then(() => {
						this.selectedCategory = null;
						this.messageContent = '';
						this.queuechatSelecionadas = []; 
						this.showRegisterMessage = false;
						this.loadMensagens();
						this.isEditing = false;
						this.editingMessage = null;
					});
				})
				.catch(error => {
					console.error('Erro ao salvar mensagem:', error);
					Swal.fire(
						'Erro',
						this.isEditing ? 'Houve um erro ao atualizar a mensagem!' : 'Houve um erro ao cadastrar a mensagem!',
						'error'
					);
				});
		},


		editMessage(msg, index) {
			this.isEditing = true;
			this.selectedCategory = msg.category_id;
			this.messageContent = msg.content;
			this.editingMessage = msg;

			const selectedCat = this.categorias.find(cat => cat.id === msg.category_id);
			this.queuechatSelecionadas = selectedCat?.queuechat || [];

			this.showRegisterMessage = true;
		}
			,

		deleteMessage(msgId, index) {
			Swal.fire({
				title: 'Tem certeza?',
				text: "Você não poderá reverter isso!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Sim, deletar!'
			}).then((result) => {
				if (result?.value == true) {
					axios.delete(`deleteMessage/${msgId}`)
						.then(() => {
							Swal.fire(
								'Deletada!',
								'Mensagem deletada com sucesso.',
								'success'
							);
							this.loadMensagens();
						})
						.catch(error => {
							console.error('Erro ao deletar a mensagem:', error);
							Swal.fire(
								'Erro',
								'Houve um erro ao deletar a mensagem',
								'error'
							);
						});
				}
			});
		}

	},

	watch: {
		getDataConnectLine(val) {
			this.nameContact = val.name;
		}
	}
}
</script>

<style scoped lang="scss">

.custom-select-wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .select-helper-text {
    font-size: 0.75rem;
    color: #666;
    margin-bottom: 4px;
  }

  .custom-height-select {
  min-height: 180px;
  max-height: 100%;
  overflow-y: auto;
}


}


.cinza {
  background-color: #f1f1f1 !important;
}

.branco {
  background-color: #ffffff !important;
}

.category-list {
  background-color: #f5f5f5; 
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 20px;
}

.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #ddd;
  font-weight: 500;
  font-size: 15px;
  color: #333;
}

.category-item:last-child {
  border-bottom: none;
}

.category-item:hover {
  background-color: #eaeaea;
}

.category-item .actions {
  display: flex;
  gap: 10px;
}

.rounder {
	border-radius: 0.5em 0 0 0.5em !important;
}
.input-group-text {
	border-radius: 0 0.5em 0.5em 0 !important;
	width: 37px !important;
	border: 1px solid #ccc !important;
	background-color: white !important;
}

.btn-icon {
    background: none;
    border: none;
    padding: 2px;
    cursor: pointer;
    
    .icon-edit {
        color: #1668b4;
        transition: 0.5s ease-in-out;

        &:hover {
          color: #093157;
        }
    }
    
    .icon-delete {
        color: #060404;
        transition: 0.5s ease-in-out;

        &:hover {
          color: #790b0b;
        }
    }
}

.bg-adv {
	background-color: #0c5460;
}
.bg-active {
	background-color: #1b6f7d;
}
.list-group {
	border-radius: 0 !important;
}

.button-group{
  width: 100%;
  gap: 20px;
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  
  button {
    padding: 5px;
    margin: 3px;
    border-radius: 7px !important;
    outline: none;
    font-weight: bold;
    width: 200px;
    transition: 0.5s ease-in-out;
    font-size: smaller;
    white-space: nowrap;
  }
  
  .new-category-button {
    background-color: white;
    color: #0c5460;
    border: 2px solid #0c5460;

    &:hover {
      background-color: #0c536033;
    }
  }
  
  .new-message-button {
    background-color: white;
    color: #074807;
    border: 2px solid #074807;

    &:hover {
      background-color: #07480736;
    }
  }

  .cancel-button {
    background-color: #bd1212;
    color: white;
    width: 100px;
    border: none;

    &:hover {
      background-color: #790b0b;
    }
  }
}

.message-button-group{
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px;
  
  button {
    padding: 5px;
    margin: 3px;
    border-radius: 7px !important;
    outline: none;
    font-weight: bold;
    width: 200px;
    transition: 0.5s ease-in-out;
    font-size: smaller;
    white-space: nowrap;
  }
  
  .message-variables-buttons {
    display: flex;
    button {
      background-color: white;
      color: #0c5460;
      border: 2px solid #0c5460;
      width: unset;
  
      &:hover {
        background-color: #0c536033;
      }
    }
  }
  
  .save-button {
    background-color: #0c5460;
    color: white;
    border: none;

    &:hover {
      background-color: #09414b;
    }
  }

  .cancel-button {
    background-color: #bd1212;
    color: white;
    width: 100px;
    border: none;

    &:hover {
      background-color: #790b0b;
    }
  }
}

.balloon::v-deep {
	p {
		position: relative;
		max-width: 82%;
		background-color: #ccc;
		padding: 1em;
		font-size: 1em;
		border-radius: 0.7rem 0 0.7rem 0.7rem;
		cursor: pointer;
		margin-left: 15%;
		overflow-wrap: break-word;
		

		&:hover {
			box-shadow:	0 0.125rem 0.5rem rgba(0, 0, 0, .3), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);
		}

		&::before {
			content: '';
			width: 0;
			height: 0;
			position: absolute;
			border-left: 15px solid #ccc;
			border-right: 15px solid transparent;
			border-top: 15px solid #ccc;
			border-bottom: 15px solid transparent;
			right: -16px;
			top: 0;
		}
	}


	.balloon-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1em;
		width: 100%;
	}

	.message-content {
		margin: 0;
		flex-grow: 1;
		cursor: pointer;
	}

  .message-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}
.modal-body {
  padding: 10;
}
.obs-span {
  font-size: x-small;
  margin: 3px;
  padding: 3px;
}
</style>